import { takeLatest } from "redux-saga/effects";
import { GetList } from "../../StateManagement/Reducers/HealthProfileState";
import { Lists } from "./HealthProfileSagaWorkers";

export function* ListSaga() {
  yield takeLatest(GetList.type, Lists);
}
